import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { HttpErrorResponse, HttpResponse, HttpStatusCode } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'

import { ToastService } from '@app/overlays/toast/toast.service'
import { MemberService } from '@app/services/member.service'

@Injectable()
export class SbInterceptor implements HttpInterceptor {
  private readonly toastService = inject(ToastService)
  private readonly memberService = inject(MemberService)

  private static version: string | null = null

  private static checkVersion(data: HttpEvent<any>): void {
    if (data instanceof HttpResponse && window.location.hash !== '#VersionReload') {
      const version = data.headers.get('SB-Version')
      if (SbInterceptor.version === null) {
        SbInterceptor.version = version
      }
      if (SbInterceptor.version !== null && version !== null && version > SbInterceptor.version) {
        window.location.reload()
      }
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(
        err =>
          new Observable<HttpEvent<any>>(observer => {
            const excludeUrl = !err.url.includes('track_')
            if (
              err instanceof HttpErrorResponse &&
              err.status === HttpStatusCode.Locked &&
              excludeUrl &&
              this.memberService.account.impersonated
            ) {
              this.toastService.show('Interactions are disabled. You are in the Impersonation mode', 3000)
            }
            if (err.error?.destination) {
              window.location.href = err.error.destination
            }
            observer.error(err)
          }),
      ),
      tap(
        event => SbInterceptor.checkVersion(event),
        error => SbInterceptor.checkVersion(error),
      ),
    )
  }
}
